var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hasToShowAlertForGuest,
      expression: "hasToShowAlertForGuest"
    }],
    staticClass: "alert-container accent",
    class: {
      'alert-container-sticky': _vm.hasToBeSticky
    },
    attrs: {
      "id": "guestAlert"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "text",
    class: _vm.$breakpoint.tabletAndUp ? 'text-l-large-bold' : 'text-m-large-bold'
  }, [_vm._v("Earn special requirements for free.")]), _c('v-btn', {
    staticClass: "heading heading-s-small primary--text shadow-light-button",
    class: {
      'ml-2': _vm.$breakpoint.mobileAndDown,
      'ml-4': _vm.$breakpoint.tabletAndUp
    },
    attrs: {
      "ripple": "",
      "depressed": "",
      "height": "36px",
      "width": "auto",
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v(" Start free trial ")])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }